var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Receipt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7273 13.6667L13.2521 14.9651C13.3171 14.9885 13.3858 15 13.4545 15C13.5621 15 13.6687 14.9716 13.7603 14.916C13.91 14.825 14 14.6734 14 14.5111V2C14 1.5 13.5 1 13 1H3C2.5 1 2 1.5 2 2V14.5111C2 14.6734 2.09002 14.825 2.2397 14.916C2.38991 15.0069 2.58061 15.0251 2.74787 14.9651L5.27273 13.6667L7.79759 14.9651C7.92756 15.0115 8.07244 15.0115 8.20241 14.9651L10.7273 13.6667ZM8 13.9448L5.27273 12.5422L3 13.711V2.04273C2.9999 2.04287 3.0001 2.04258 3 2.04273C3.005 2.03567 3.01181 2.02741 3.01961 2.01961C3.02741 2.01181 3.03524 2.0053 3.0423 2.0003C3.04215 2.0004 3.04244 2.0002 3.0423 2.0003L12.9573 2C12.9571 1.9999 12.9574 2.0001 12.9573 2C12.9643 2.005 12.9726 2.01181 12.9804 2.01961C12.9882 2.02741 12.9947 2.03524 12.9997 2.0423C12.9996 2.04215 12.9998 2.04244 12.9997 2.0423L13 13.711L10.7273 12.5422L8 13.9448Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5C5.25 4.72386 5.47386 4.5 5.75 4.5H10.25C10.5261 4.5 10.75 4.72386 10.75 5C10.75 5.27614 10.5261 5.5 10.25 5.5H5.75C5.47386 5.5 5.25 5.27614 5.25 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 8C5.25 7.72386 5.47386 7.5 5.75 7.5H10.25C10.5261 7.5 10.75 7.72386 10.75 8C10.75 8.27614 10.5261 8.5 10.25 8.5H5.75C5.47386 8.5 5.25 8.27614 5.25 8Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.4d256422d5d5c12a9552b147fde8eee4.svg";
export { ForwardRef as ReactComponent };